<mapp-action-modal
    [title]="'Custom Session Timeout Warning'"
    [iconPath]="'icon-clock-24'"
    [description]="description"
    [primaryButton]="primaryButton"
    [secondaryButton]="secondaryButton"
></mapp-action-modal>
